import { assign } from 'lodash';

export abstract class BaseEntity<T> {
  id?: string;

  public deserialize(object: T): this {
    assign(this, object);
    return this;
  }
}
